import { calorieSplit, formatMacro } from './format'

/**
 * Format per-serving macros into display strings plus the calorie split.
 *
 * Values arrive rounded from the API; missing values are already normalised to
 * zero there, so an untracked macro reads as 0 rather than "unknown".
 */
export function formatDaysLabel(perServing: {
  calories: number
  protein: number
  carbs: number
  fat: number
  fiber: number
}) {
  const split = calorieSplit(perServing.protein, perServing.carbs, perServing.fat)
  return {
    calories: formatMacro(perServing.calories),
    protein: formatMacro(perServing.protein),
    carbs: formatMacro(perServing.carbs),
    fat: formatMacro(perServing.fat),
    fiber: formatMacro(perServing.fiber),
    proteinPct: split?.proteinPct ?? 0,
    carbsPct: split?.carbsPct ?? 0,
    fatPct: split?.fatPct ?? 0,
  }
}